/* eslint-disable react/no-danger */
import { Link } from 'gatsby';
import _ from 'lodash';
import React from 'react';
import { motion } from 'framer-motion';
import { LazyLoadImage } from 'react-lazy-load-image-component';

export default function FreeZoneTextContentWithTwoOverlapImage({ data, id }) {
  const { title, text, firstImage, firstImageMobile, video, link } = data;
  return (
    <section id={id} className="py-[45px] md:py-[80px]">
      <div className="max-w-[1752px] mx-auto relative px-4">
        <div className="flex flex-col-reverse md:flex-row gap-[30px] md:gap-0 overflow-hidden">

          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.4 }}
            viewport={{ once: true }}
            className="md:max-w-[43.313953%] flex
            flex-col gap-y-5 md:gap-y-10 md:pt-5 2xl:ltr:pl-[56px] 2xl:rtl:pr-[56px]">

            <div className="flex md:max-w-[595px] pr-6 flex-col gap-y-5 md:gap-y-7">
              <div
                dangerouslySetInnerHTML={{ __html: title }}
                className="text-clamp20to40  h2-child:text-clamp20to40 text-[#231F20]
                h2-child:leading-1.2 
                h2-child:!m-0 md:max-w-[370px] ltr:md:text-left
                rtl:md:text-right text-center [&>h2>br]:hidden [&>h2>br]:md:inline-block"
              />
              <div className="h-[2px] w-[50px] md:w-[70px] bg-[#CE445B] mx-auto md:mx-0" />
            </div>

            <div
              dangerouslySetInnerHTML={{ __html: text }}
              className="p-child:text-[#4D4D4D] p-child:text-clamp12to18 p-child:font-normal
                p-child:leading-[1.6] p-child:mb-0 p-child:ltr:font-URWDINRegular 
                p-child:rtl:font-GESSTwoDWTCLight ltr:md:text-left
                rtl:md:text-right text-center md:max-w-[605px] md:ltr:pr-6 md:rtl:pl-6"
            />

            {_.isEmpty(link) || (
              <div className="w-full flex justify-center md:justify-start md:w-fit">
                <Link
                  href={link.url}
                  className="sheikh-rashid-tower-cta w-fit flex justify-center items-center
                            rounded-[48px] bg-[#CE445B] hover:bg-[#B53B50] text-white uppercase 
                            font-URWDINBold pt-1 ltr:tracking-[0.96px] leading-1 
                            h-10 md:h-[49px] text-[11px]
                            md:text-[15px] px-12 md:px-14">
                  {link.name}
                </Link>
              </div>
            )}

          </motion.div>

          <div
            className="overflow-hidden md:overflow-visible relative w-[975px] max-w-full 
            md:max-w-[56.686047%] ltr:ml-auto ltr:mr-0 rtl:mr-auto rtl:ml-0">
              
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.4, delay: 0.6 }}
              viewport={{ once: true }}
              className="w-[82.333333%] lg:w-[77.333333%] relative h-full pb-8 xl:pb-15">

              {_.isEmpty(firstImage) || (
                <LazyLoadImage
                  src={firstImage.url}
                  alt="Convention Tower 2"
                  width="100%"
                  effect="blur"
                  wrapperClassName="!hidden md:!block h-full aspect-[244/176] md:aspect-[754/620] 
                  overflow-hidden"
                  className="w-full h-full aspect-[244/176] md:aspect-[754/620] object-cover"
                />
              )}

              {_.isEmpty(firstImageMobile) || (
                <LazyLoadImage
                  src={firstImageMobile.url}
                  alt="Convention Tower 2"
                  width="100%"
                  effect="blur"
                  wrapperClassName="md:!hidden h-full aspect-[244/176] overflow-hidden"
                  className="w-full h-full aspect-[244/176] object-cover"
                />
              )}

              {_.isEmpty(video) || (
                <div className="absolute 
                rtl:right-full rtl:translate-x-1/2
                ltr:left-full ltr:-translate-x-1/2 bottom-0 
                aspect-[130/100] lg:aspect-[467/363] w-[43.75%] md:w-[42.86%] lg:w-[59%] 
                2xl:w-[467px]">
                <video
                  src={video}
                  muted
                  autoPlay
                  playsInline
                  loop
                  className="w-full aspect-[120/100] lg:aspect-[467/363] h-full object-cover"
                />
                </div>
              )}
              
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
